module.exports = __webpack_public_path__ + "img/feature-import-2.5441f3df.jpg";